// patterns of urls to hide alerts component on
const hideOnPaths = [
    /^\/sitepass\//,
    /^\/camping\/campgrounds\//,
    /^\/camping\/gateways\//,
    /^\/timed-entry\//,
    /^\/ticket\//,
    /^\/tree-permits\//,
    /^\/activitypass\//,
];

// patterns of urls to included alerts component on (these will override
// anything matching in hideOnPaths)
const showOnPaths = [];

export default function getHeaderAlertsVisibilityByLocation(location) {
    // cache of previous evaluations
    const showOnCache = {};
    let result = true;

    if (location) {
        const { pathname } = location;
        // check cached result first
        result = showOnCache[pathname];

        if (!result) {
            result = true;
            let found = false;
            // check if pathname is listed in showOnPaths list
            for (let i = 0, len = showOnPaths.length; i < len; i++) {
                if (showOnPaths[i].exec(pathname) !== null) {
                    found = true;
                    break;
                }
            }
            if (!found) {
                // if pathname is not listed on showOnPaths, then check whether it's included
                // into hideOnPaths
                for (let i = 0, len = hideOnPaths.length; i < len; i++) {
                    if (hideOnPaths[i].exec(pathname) !== null) {
                        result = false;
                        break;
                    }
                }
            }
            showOnCache[pathname] = result;
        }
    }
    return result;
}
